export const autoCompleteStyles = ({ multiSelect, multiLine, isMobile, isValuePresent, label, disabled, isFreeText }) => {
    return {
        container: ({ breakpoints, palette }) => ({
            [breakpoints.up("sm")]: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "stretch",
                alignItems: "flex-end",
                width: "100%",
                backgroundColor: palette.common.white,
                "& .MuiFormControl-root": {
                    height: "inherit"
                },
                "& .MuiAutocomplete": {
                    "&-root": {
                        backgroundColor: palette.common.white,
                        width: multiSelect ? "100%" : "",
                        flex: multiSelect ? 1 : 2,
                        height: multiLine || multiSelect ? "auto" : "1.875rem",
                        "& .MuiAutocomplete-inputRoot.MuiFilledInput-root": {
                            height: "inherit",
                            "& .MuiFilledInput-input": {
                                padding: "5.66px 4px"
                            }
                        }
                    },
                    '&-hasPopupIcon .MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot[class*="MuiFilledInput-root"]': {
                        width: "100%",
                        paddingRight: multiSelect ? 15 : "",
                        paddingLeft: 30
                    },
                    "&-endAdornment": {
                        //Notoriously adjust alignment of adornments on to the bottom of container for all select options.
                        top: "inherit",
                        bottom: multiSelect ? 0 : ""
                    },
                    "&-inputRoot": {
                        paddingLeft: !label && "1px",
                        justifyContent: "flex-start",
                        '&[class*="MuiFilledInput-root"]': {
                            paddingTop: multiSelect && isValuePresent ? (!isMobile ? 5 : 0) : 0,
                            width: "100%",
                            "& .MuiAutocomplete-endAdornment": {
                                right: 2
                            }
                        }
                    }
                }
            },
            [breakpoints.down("sm")]: {
                flexDirection: "column",
                alignItems: "flex-start",
                backgroundColor: "transparent",
                "& .MuiAutocomplete": {
                    "&-inputRoot": {
                        paddingLeft: "0px",
                        '&[class*="MuiFilledInput-root"]': {
                            paddingTop: !label ? 0 : ""
                        }
                    },
                    "&-endAdornment": {
                        //Notoriously adjust alignment of adornments on to the bottom of container for all select options.
                        top: multiSelect ? "inherit" : "",
                        bottom: multiSelect ? 0 : ""
                    }
                }
            },
            "& .MuiAutocomplete": {
                "&-clearIndicator": {
                    borderRadius: 50,
                    marginRight: 0,
                    "&:hover": {
                        color: palette.controls.input.border.hover,
                        backgroundColor: palette.background.hover
                    },
                    "&:active": {
                        color: palette.common.white,
                        backgroundColor: palette.background.active
                    }
                },
                "&-popupIndicator": {
                    marginLeft: 2,
                    color: palette.controls.input.border.hover,
                    borderRadius: !isMobile && "0px",
                    height: 30,
                    width: 30,
                    "&:hover": {
                        backgroundColor: palette.background.hover
                    },
                    "&:active": {
                        color: palette.common.white,
                        backgroundColor: palette.background.active
                    },
                    "&.Mui-disabled": {
                        opacity: 0.4
                    },
                    "&[aria-label='Close']": {
                        backgroundColor: palette.background.active
                    }
                },
                "&-popupIndicatorOpen": {
                    color: palette.common.white,
                    backgroundColor: palette.background.active
                },
                "&-inputRoot": {
                    "& .MuiAutocomplete-input": {
                        width: "100%",
                        "&::placeholder": {
                            color: palette.text.secondary,
                            fontStyle: "italic",
                            opacity: 1
                        },
                        "&:focus::placeholder": {
                            color: "transparent" // placeholder text to disappear on focus of input not first character
                        }
                    },
                    "& input.MuiAutocomplete-input.MuiFilledInput-input": {
                        height: "inherit",
                        lineHeight: 1.5
                    }
                }
            },
            "& .MuiFilledInput-underline": {
                transition: "none",
                borderBottom: "none",
                "&::before": {
                    borderBottom: "none !important"
                },
                "&::after": {
                    borderBottom: "none !important"
                }
            },
            "& .MuiFilledInput-root": {
                "&:hover": {
                    backgroundColor: disabled ? palette.background.disabled : isMobile ? "transparent" : palette.common.white
                },
                backgroundColor: disabled ? palette.background.disabled : isMobile ? "transparent" : palette.common.white,
                border: multiSelect && isValuePresent ? `solid 1px ${palette.controls.input.border.main}` : "",
                borderBottom: multiSelect && isValuePresent ? "none" : "",
                borderRadius: 0,
                "&.Mui-focused": {
                    backgroundColor: multiSelect && isValuePresent ? palette.controls.grid.rowGroup.backgroundColor : ""
                }
            },
            "& .MuiInputBase-multiline": {
                paddingBottom: isFreeText ? 0 : ""
            }
        }),
        autocomplete: {
            width: "100%",
            "&:focus": {
                minWidth: 10
            }
        }
    };
};
